import React, {forwardRef} from "react";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @Description Element container principal.
 * @param {JSX.Element} children:  Elements that will be the content of the component (required).
 * @param ref element reference
 * @returns {JSX.Element}
 */
const DivContainerBody = forwardRef(({ children }, ref) => {

    return (
        <div className='container-body' ref={ref}>
            {children}
        </div>
    )
})

export default DivContainerBody
